"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var options;
var spotifyAxiosInstance;

var setupRefresh = function setupRefresh(refreshTokenFunction) {
  spotifyAxiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.config && !error.config.__isRetryRequest && error.response && error.response.status === 401) {
      error.config.__isRetryRequest = true;
      return refreshTokenFunction(options.refreshToken).then(function (token) {
        error.config.headers.Authorization = "Bearer " + token;
        return axios_1.default.request(error.config);
      });
    }

    return Promise.reject(error);
  });
};

exports.init = function (config) {
  options = config;
  spotifyAxiosInstance = axios_1.default.create({
    baseURL: 'https://api.spotify.com/v1',
    headers: {
      Authorization: "Bearer " + options.token
    }
  });

  if (options.refreshTokenFunction) {
    setupRefresh(options.refreshTokenFunction);
  }
};

exports.getToken = function () {
  if (options) return options.token;
  throw new Error('You must log in first');
};

exports.getAxiosSpotifyInstance = function () {
  if (spotifyAxiosInstance) return spotifyAxiosInstance;
  throw new Error('You must log in first');
};